import React from 'react'

import './button.scss'

const ButtonLink = ({ children, ...rest }) => (
  <button type='button' className='button-link' {...rest}>{children}</button>
)

export default ButtonLink
